// extracted by mini-css-extract-plugin
export default {"button":"_3HL65","buttonIcon":"VSHhP"};